(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coupon-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coupon-offers')) {
    class CouponOffers extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearInterval(this.interval);
        this.events?.abort();
      }

      initialize() {
        this.events?.abort();
        clearInterval(this.interval);
        this.events = new AbortController();
        this.hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-copy-code]');
          if (button && this.contains(button)) this.copyCode(button);
        }, { signal: this.events.signal });

        this.bar = this.querySelector('[data-countdown-bar]');
        this.clock = this.querySelector('[data-countdown-clock]');
        this.expired = this.querySelector('[data-countdown-expired]');
        if (!this.bar || !this.clock) return;
        this.bar.hidden = false;
        this.clock.hidden = true;
        this.expired.hidden = true;
        this.end = this.parseDate(this.dataset.end);
        const error = this.querySelector('[data-date-error]');
        if (error) error.hidden = !this.dataset.end || Number.isFinite(this.end);
        if (!Number.isFinite(this.end)) return;
        this.values = {};
        this.querySelectorAll('[data-time]').forEach((node) => { this.values[node.dataset.time] = node; });
        this.tick();
        if (this.end > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.tick();
        }, { signal: this.events.signal });
      }

      parseDate(input) {
        // Require an explicit time zone; reject rolled-over dates such as February 30.
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|([+-])(\d{2}):(\d{2}))$/.exec(input || '');
        if (!match) return NaN;
        const [, year, month, day, hour, minute, second, zone, , zoneHour, zoneMinute] = match;
        if (+year < 2000 || +month < 1 || +month > 12 || +day < 1 || +day > new Date(Date.UTC(+year, +month, 0)).getUTCDate() || +hour > 23 || +minute > 59 || +second > 59) return NaN;
        if (zone !== 'Z' && (+zoneHour > 14 || +zoneMinute > 59 || (+zoneHour === 14 && +zoneMinute !== 0))) return NaN;
        return Date.parse(input);
      }

      tick() {
        const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        if (!remaining) {
          clearInterval(this.interval);
          this.clock.hidden = true;
          this.expired.hidden = false;
          if (this.dataset.editor !== 'true') {
            if (this.dataset.expiry === 'hide_timer') this.bar.hidden = true;
            if (this.dataset.expiry === 'hide_section') this.hidden = true;
          }
          return;
        }
        const units = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        Object.entries(units).forEach(([unit, value]) => {
          const label = String(value).padStart(2, '0');
          if (this.values[unit].textContent !== label) this.values[unit].textContent = label;
        });
        this.clock.hidden = false;
        this.expired.hidden = true;
      }

      async copyCode(button) {
        const area = button.closest('.co-code-area');
        const feedback = area.querySelector('.co-feedback');
        const input = area.querySelector('.co-manual-copy');
        try {
          if (!window.isSecureContext || !navigator.clipboard) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(button.dataset.copyCode);
          if (!this.isConnected) return;
          feedback.textContent = this.dataset.copied;
          input.hidden = true;
        } catch {
          if (!this.isConnected) return;
          input.hidden = false;
          input.focus();
          input.select();
          input.setSelectionRange(0, input.value.length);
          feedback.textContent = this.dataset.copyFallback;
        }
      }
    }
    customElements.define('coupon-offers', CouponOffers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-category-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hot-category-tabs')) {
    customElements.define('hot-category-tabs', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected && !this.lifecycle) this.initialize();
        });
      }

      initialize() {
        if (this.lifecycle) return;
        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        this.tabs = Array.from(this.querySelectorAll('[data-hc-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-hc-panel]'));
        this.prev = this.querySelector('[data-hc-direction="-1"]');
        this.next = this.querySelector('[data-hc-direction="1"]');
        this.pageCount = this.querySelector('[data-hc-page-count]');
        this.viewAll = this.querySelector('[data-hc-view-all]');
        this.message = this.querySelector('[data-hc-message]');
        this.timers = new Set();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));

        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-hc-tab]');
          if (tab && this.contains(tab)) {
            event.preventDefault();
            this.activate(this.tabs.indexOf(tab), true);
          }
          const arrow = event.target.closest('[data-hc-direction]');
          if (arrow && !arrow.disabled) this.move(Number(arrow.dataset.hcDirection));
        }, { signal });
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-hc-tab]');
          if (!tab) return;
          let index = this.tabs.indexOf(tab);
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else if (event.key !== ' ') return;
          event.preventDefault();
          this.activate((index + this.tabs.length) % this.tabs.length, true);
        }, { signal });
        this.addEventListener('submit', event => {
          const form = event.target.closest('.hc-form');
          if (!form) return;
          event.preventDefault();
          this.addToCart(form);
        }, { signal });
        this.panels.forEach(panel => {
          const grid = panel.querySelector('[data-hc-grid]');
          if (!grid) return;
          grid.addEventListener('scroll', () => this.updateButtons(), { passive: true, signal });
          ['pointerdown', 'wheel', 'keydown'].forEach(type => {
            grid.addEventListener(type, () => this.stopAnimation(), { passive: true, signal });
          });
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.activate(index, false);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          this.stopAnimation();
          this.updateButtons();
        });
        this.resizeObserver.observe(this);
        this.panels.forEach(panel => {
          const grid = panel.querySelector('[data-hc-grid]');
          if (grid) this.resizeObserver.observe(grid);
        });
        this.activate(this.activeIndex, false);
        this.updateButtons();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.lifecycle?.abort();
        this.lifecycle = null;
        this.resizeObserver?.disconnect();
        this.stopAnimation();
        this.timers?.forEach(timer => clearTimeout(timer));
        cancelAnimationFrame(this.layoutFrame);
      }

      refresh() {
        this.disconnectedCallback();
        if (this.isConnected) this.connectedCallback();
      }

      activate(index, focus) {
        if (!this.tabs[index]) return;
        this.stopAnimation();
        const changed = this.activeIndex !== index;
        this.activeIndex = index;
        const panelId = this.tabs[index].getAttribute('aria-controls');
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach(panel => {
          const selected = panel.id === panelId;
          panel.hidden = !selected;
          panel.toggleAttribute('inert', !selected);
          panel.classList.toggle('is-active', selected);
        });
        const activePanel = this.panels.find(panel => panel.id === panelId);
        this.grid = activePanel?.querySelector('[data-hc-grid]');
        if (this.viewAll) {
          const collectionUrl = activePanel?.dataset.hcCollectionUrl || '';
          this.viewAll.hidden = !collectionUrl;
          if (collectionUrl) this.viewAll.setAttribute('href', collectionUrl);
          else this.viewAll.removeAttribute('href');
        }
        if (changed && this.grid) this.grid.scrollLeft = 0;
        [this.prev, this.next].forEach(button => {
          if (!button) return;
          if (this.grid) button.setAttribute('aria-controls', this.grid.id);
          else button.removeAttribute('aria-controls');
        });
        if (focus) {
          const tab = this.tabs[index];
          tab.focus({ preventScroll: true });
          const nav = tab.parentElement;
          const navRect = nav.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          if (tabRect.left < navRect.left) nav.scrollLeft += tabRect.left - navRect.left;
          else if (tabRect.right > navRect.right) nav.scrollLeft += tabRect.right - navRect.right;
        }
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.updateButtons());
      }

      metrics() {
        if (!this.grid) return { max: 0, position: 0, step: 0, count: 0, sign: 1 };
        const styles = getComputedStyle(this.grid);
        const sign = styles.direction === 'rtl' ? -1 : 1;
        const gap = parseFloat(styles.columnGap) || 0;
        const step = (this.grid.firstElementChild?.getBoundingClientRect().width || 0) + gap;
        return {
          sign,
          max: Math.max(0, this.grid.scrollWidth - this.grid.clientWidth),
          position: Math.max(0, this.grid.scrollLeft * sign),
          step,
          count: step ? Math.max(1, Math.round((this.grid.clientWidth + gap) / step)) : 1
        };
      }

      updateButtons() {
        if (!this.prev || !this.next) return;
        const { max, position, step, count } = this.metrics();
        this.prev.disabled = max <= 1 || position <= 1;
        this.next.disabled = max <= 1 || position >= max - 1;
        if (this.pageCount) {
          const items = this.grid?.children.length || 0;
          const pages = items ? Math.ceil(items / Math.max(1, count)) : 0;
          let page = items ? 1 : 0;
          if (pages > 1) {
            page = position >= max - 1 ? pages : Math.min(pages, Math.floor((position + 1) / (step * count)) + 1);
          }
          const text = page + ' / ' + pages;
          if (this.pageCount.textContent !== text) this.pageCount.textContent = text;
        }
      }

      stopAnimation() {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.scrollTarget = null;
        this.grid?.classList.remove('is-animating');
      }

      move(direction) {
        if (!this.grid) return;
        const metrics = this.metrics();
        if (!metrics.max || !metrics.step) return;
        const origin = this.scrollTarget ?? metrics.position;
        const target = Math.max(0, Math.min(metrics.max,
          (Math.round(origin / metrics.step) + direction * metrics.count) * metrics.step));
        this.stopAnimation();
        const grid = this.grid;
        if (this.motion.matches) {
          grid.scrollLeft = target * metrics.sign;
          this.updateButtons();
          return;
        }
        const start = metrics.position;
        const startTime = performance.now();
        const duration = 650;
        this.scrollTarget = target;
        grid.classList.add('is-animating');
        const tick = now => {
          const progress = Math.min(1, (now - startTime) / duration);
          const ease = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
          grid.scrollLeft = (start + (target - start) * ease) * metrics.sign;
          if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
          else {
            this.stopAnimation();
            this.updateButtons();
          }
        };
        this.animationFrame = requestAnimationFrame(tick);
      }

      async addToCart(form) {
        const button = form.querySelector('[type="submit"]');
        if (!button || button.disabled || this.cartBusy) return;
        const label = button.querySelector('[data-hc-button-label]');
        const defaultLabel = label.dataset.defaultLabel || label.textContent;
        label.dataset.defaultLabel = defaultLabel;
        clearTimeout(button.hcTimer);
        this.timers.delete(button.hcTimer);
        this.cartBusy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.adding;
        this.message.hidden = true;
        const body = new FormData(form);
        let cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        let sectionIds = [];
        let added = false;
        try {
          if (cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function') {
            try {
              sectionIds = [...new Set(cart.getSectionsToRender().map(section => section.id))].slice(0, 5);
              cart.setActiveElement?.(button);
            } catch (_) { cart = null; }
          } else { cart = null; }
          if (cart && sectionIds.length) {
            body.set('sections', sectionIds.join(','));
            body.set('sections_url', window.location.pathname);
          }
          const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || state.message || this.dataset.error);
          added = true;
          label.textContent = this.dataset.added;
          if (!cart || !sectionIds.length) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const hasSections = () => {
            if (!sectionIds.every(id => typeof state.sections?.[id] === 'string' && state.sections[id].trim())) return false;
            if (cart.localName !== 'cart-drawer') return true;
            const html = new DOMParser().parseFromString(state.sections['cart-drawer'] || '', 'text/html');
            return Boolean(html.querySelector('#CartDrawer .drawer__inner'));
          };
          // Rendering may fail after a successful add. Retry only the GET, never the POST.
          if (!hasSections()) {
            const url = new URL(window.location.href);
            url.searchParams.delete('section_id');
            url.searchParams.set('sections', sectionIds.join(','));
            const refresh = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!refresh.ok) throw new Error('Cart sections unavailable');
            state.sections = await refresh.json();
            if (!hasSections()) throw new Error('Cart sections unavailable');
          }
          cart.classList.remove('is-empty');
          cart.renderContents(state);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try {
              await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hot-category-tabs', productVariantId: body.get('id'), cartData: state });
            } catch (_) { /* The item was added and the cart was already rendered. */ }
          }
          this.showMessage(this.dataset.added, false);
        } catch (error) {
          if (added) {
            label.textContent = this.dataset.added;
            this.showMessage(this.dataset.added + ' ', false, true);
          } else {
            label.textContent = defaultLabel;
            this.showMessage(error.message || this.dataset.error, true, true);
          }
        } finally {
          this.cartBusy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (this.isConnected) {
            button.hcTimer = setTimeout(() => {
              label.textContent = defaultLabel;
              this.timers.delete(button.hcTimer);
            }, 1800);
            this.timers.add(button.hcTimer);
          }
        }
      }

      showMessage(text, error, link) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.classList.toggle('is-error', error);
        if (link) {
          const anchor = document.createElement('a');
          anchor.href = this.dataset.cartUrl;
          anchor.textContent = this.dataset.viewCart;
          this.message.append(document.createTextNode(' '), anchor);
        }
        this.message.hidden = false;
      }
    });
    document.addEventListener('shopify:section:load', event => {
      const sections = event.target.matches?.('hot-category-tabs')
        ? [event.target]
        : event.target.querySelectorAll('hot-category-tabs');
      sections.forEach(section => section.refresh());
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-products-tab"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hot-product-carousel')) {
    customElements.define('hot-product-carousel', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected && !this.lifecycle) this.initialize();
        });
      }

      initialize() {
        if (this.lifecycle) return;
        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        this.grid = this.querySelector('[data-hc-grid]');
        this.prev = this.querySelector('[data-hc-direction="-1"]');
        this.next = this.querySelector('[data-hc-direction="1"]');
        this.pageCount = this.querySelector('[data-hc-page-count]');
        this.message = this.querySelector('[data-hc-message]');
        this.timers = new Set();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', event => {
          const arrow = event.target.closest('[data-hc-direction]');
          if (arrow && !arrow.disabled) this.move(Number(arrow.dataset.hcDirection));
        }, { signal });
        this.addEventListener('submit', event => {
          const form = event.target.closest('.hc-form');
          if (!form) return;
          event.preventDefault();
          this.addToCart(form);
        }, { signal });
        if (this.grid) {
          this.grid.addEventListener('scroll', () => this.updateButtons(), { passive: true, signal });
          ['pointerdown', 'wheel', 'keydown'].forEach(type => {
            this.grid.addEventListener(type, () => this.stopAnimation(), { passive: true, signal });
          });
        }
        [this.prev, this.next].forEach(button => {
          if (!button) return;
          if (this.grid) button.setAttribute('aria-controls', this.grid.id);
          else button.removeAttribute('aria-controls');
        });
        this.resizeObserver = new ResizeObserver(() => {
          this.stopAnimation();
          this.updateButtons();
        });
        this.resizeObserver.observe(this);
        if (this.grid) this.resizeObserver.observe(this.grid);
        this.updateButtons();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.lifecycle?.abort();
        this.lifecycle = null;
        this.resizeObserver?.disconnect();
        this.stopAnimation();
        this.timers?.forEach(timer => clearTimeout(timer));
      }

      refresh() {
        this.disconnectedCallback();
        if (this.isConnected) this.connectedCallback();
      }

      metrics() {
        if (!this.grid) return { max: 0, position: 0, step: 0, count: 0, sign: 1 };
        const styles = getComputedStyle(this.grid);
        const sign = styles.direction === 'rtl' ? -1 : 1;
        const gap = parseFloat(styles.columnGap) || 0;
        const step = (this.grid.firstElementChild?.getBoundingClientRect().width || 0) + gap;
        return {
          sign,
          max: Math.max(0, this.grid.scrollWidth - this.grid.clientWidth),
          position: Math.max(0, this.grid.scrollLeft * sign),
          step,
          count: step ? Math.max(1, Math.round((this.grid.clientWidth + gap) / step)) : 1
        };
      }

      updateButtons() {
        if (!this.prev || !this.next) return;
        const { max, position, step, count } = this.metrics();
        this.prev.disabled = max <= 1 || position <= 1;
        this.next.disabled = max <= 1 || position >= max - 1;
        if (this.pageCount) {
          const items = this.grid?.children.length || 0;
          const pages = items ? Math.ceil(items / Math.max(1, count)) : 0;
          let page = items ? 1 : 0;
          if (pages > 1) {
            page = position >= max - 1 ? pages : Math.min(pages, Math.floor((position + 1) / (step * count)) + 1);
          }
          const text = page + ' / ' + pages;
          if (this.pageCount.textContent !== text) this.pageCount.textContent = text;
        }
      }

      stopAnimation() {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.scrollTarget = null;
        this.grid?.classList.remove('is-animating');
      }

      move(direction) {
        if (!this.grid) return;
        const metrics = this.metrics();
        if (!metrics.max || !metrics.step) return;
        const origin = this.scrollTarget ?? metrics.position;
        const pageStep = metrics.step * metrics.count;
        const targetPage = direction > 0
          ? Math.floor((origin + 1) / pageStep) + 1
          : Math.ceil((origin - 1) / pageStep) - 1;
        const target = Math.max(0, Math.min(metrics.max, targetPage * pageStep));
        this.stopAnimation();
        const grid = this.grid;
        if (this.motion.matches) {
          grid.scrollLeft = target * metrics.sign;
          this.updateButtons();
          return;
        }
        const start = metrics.position;
        const startTime = performance.now();
        const duration = 650;
        this.scrollTarget = target;
        grid.classList.add('is-animating');
        const tick = now => {
          const progress = Math.min(1, (now - startTime) / duration);
          const ease = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
          grid.scrollLeft = (start + (target - start) * ease) * metrics.sign;
          if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
          else {
            this.stopAnimation();
            this.updateButtons();
          }
        };
        this.animationFrame = requestAnimationFrame(tick);
      }

      async addToCart(form) {
        const button = form.querySelector('[type="submit"]');
        if (!button || button.disabled || this.cartBusy) return;
        const label = button.querySelector('[data-hc-button-label]');
        const defaultLabel = label.dataset.defaultLabel || label.textContent;
        label.dataset.defaultLabel = defaultLabel;
        clearTimeout(button.hcTimer);
        this.timers.delete(button.hcTimer);
        this.cartBusy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.adding;
        this.message.hidden = true;
        const body = new FormData(form);
        let cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        let sectionIds = [];
        let added = false;
        try {
          if (cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function') {
            try {
              sectionIds = [...new Set(cart.getSectionsToRender().map(section => section.id))].slice(0, 5);
              cart.setActiveElement?.(button);
            } catch (_) { cart = null; }
          } else { cart = null; }
          if (cart && sectionIds.length) {
            body.set('sections', sectionIds.join(','));
            body.set('sections_url', window.location.pathname);
          }
          const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || state.message || this.dataset.error);
          added = true;
          label.textContent = this.dataset.added;
          if (!cart || !sectionIds.length) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const hasSections = () => {
            if (!sectionIds.every(id => typeof state.sections?.[id] === 'string' && state.sections[id].trim())) return false;
            if (cart.localName !== 'cart-drawer') return true;
            const html = new DOMParser().parseFromString(state.sections['cart-drawer'] || '', 'text/html');
            return Boolean(html.querySelector('#CartDrawer .drawer__inner'));
          };
          // Rendering may fail after a successful add. Retry only the GET, never the POST.
          if (!hasSections()) {
            const url = new URL(window.location.href);
            url.searchParams.delete('section_id');
            url.searchParams.set('sections', sectionIds.join(','));
            const refresh = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!refresh.ok) throw new Error('Cart sections unavailable');
            state.sections = await refresh.json();
            if (!hasSections()) throw new Error('Cart sections unavailable');
          }
          cart.classList.remove('is-empty');
          cart.renderContents(state);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try {
              await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hot-product-carousel', productVariantId: body.get('id'), cartData: state });
            } catch (_) { /* The item was added and the cart was already rendered. */ }
          }
          this.showMessage(this.dataset.added, false);
        } catch (error) {
          if (added) {
            label.textContent = this.dataset.added;
            this.showMessage(this.dataset.added + ' ', false, true);
          } else {
            label.textContent = defaultLabel;
            this.showMessage(error.message || this.dataset.error, true, true);
          }
        } finally {
          this.cartBusy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (this.isConnected) {
            button.hcTimer = setTimeout(() => {
              label.textContent = defaultLabel;
              this.timers.delete(button.hcTimer);
            }, 1800);
            this.timers.add(button.hcTimer);
          }
        }
      }

      showMessage(text, error, link) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.classList.toggle('is-error', error);
        if (link) {
          const anchor = document.createElement('a');
          anchor.href = this.dataset.cartUrl;
          anchor.textContent = this.dataset.viewCart;
          this.message.append(document.createTextNode(' '), anchor);
        }
        this.message.hidden = false;
      }
    });
    document.addEventListener('shopify:section:load', event => {
      const sections = event.target.matches?.('hot-product-carousel')
        ? [event.target]
        : event.target.querySelectorAll('hot-product-carousel');
      sections.forEach(section => section.refresh());
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-offer"] && !Shopify.designMode) return;
  try {
    
  const moCopyTimers = new WeakMap();

  function moFallbackCopy(code) {
    const field = document.createElement('textarea');
    const previousFocus = document.activeElement;
    field.value = code;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;';
    document.body.appendChild(field);
    try {
      field.focus({ preventScroll: true });
      field.select();
      field.setSelectionRange(0, field.value.length);
      return document.execCommand('copy');
    } finally {
      field.remove();
      if (previousFocus && previousFocus.isConnected) {
        previousFocus.focus({ preventScroll: true });
      }
    }
  }

  // Delegation also handles cards re-rendered in the Shopify theme editor.
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.mo-copy-button[data-mo-code]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    const group = button.closest('.mo-code-group');
    if (!group) return;

    const code = button.dataset.moCode;
    if (!code) return;
    const status = group.querySelector('.mo-copy-status');
    const label = button.dataset.copyLabel || 'Copy code';
    const successLabel = button.dataset.copiedLabel || 'Copied!';
    const errorLabel = button.dataset.copyError || 'Unable to copy. Please select the code and copy it manually.';
    clearTimeout(moCopyTimers.get(button));
    button.setAttribute('aria-disabled', 'true');
    if (status) {
      status.textContent = '';
      status.classList.remove('is-error');
    }

    let copied = false;
    try {
      if (window.isSecureContext && navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (error) {
          copied = moFallbackCopy(code);
        }
      } else {
        copied = moFallbackCopy(code);
      }
    } catch (error) {
      copied = false;
    } finally {
      button.removeAttribute('aria-disabled');
    }

    if (!button.isConnected) return;
    button.classList.toggle('is-copied', copied);
    button.setAttribute('aria-label', copied ? successLabel : label);
    if (status) {
      status.textContent = copied ? successLabel : errorLabel;
      status.classList.toggle('is-error', !copied);
    }
    if (copied) {
      moCopyTimers.set(button, setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', label);
        if (status) status.textContent = '';
        moCopyTimers.delete(button);
      }, 2000));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vfitz-mygarage"] && !Shopify.designMode) return;
  try {
    
class VFitzMyGarageClassicManager {
  constructor() {
    const config = window.vfitzGarageConfig || {};
    this.targetSelector = config.targetSelector || '#vfitz-mygarage';
    this.cssVars = config.cssVars || {};
    this.vehicle_null_text = config.vehicleNullText || 'Select Vehicle';

    this.cookieValue = null;
    this.garage_param = null;
    this.isInitialized = false;
    this.currentIndex = 0;
    this.searchParamsAllowKeys = ['year', 'make', 'model', 'submodel', 'engine'];

    this.hostElement = null;
    this.dom_vehicle_label = null;
    this.dom_headerNav = null;
    this.dom_dropdown = null;
    this.dom_arrow = null;

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
  }

  // Receives one matched host node from the bootstrap function; no longer uses document.querySelector, which only returns the first match
  initWithNode(hostElement) {
    this.hostElement = hostElement;
    if (!this.hostElement) return;

    this.applyCSSVars();
    this.renderLayout();
    this.initDOMReferences();
    this.bindEvents();          // Bind the click listener first, so it is not affected by whether the later data init succeeds or fails
    this.initWithEventCheck();
  }

  applyCSSVars() {
    Object.entries(this.cssVars).forEach(([key, val]) => {
      if (val && this.hostElement) this.hostElement.style.setProperty(key, val);
    });
  }

  renderLayout() {
    if (!this.hostElement) return;
    // Use a standard, conflict-free DOM structure
    this.hostElement.innerHTML = `
      <div class="vfitz-garage-nav" role="button" tabindex="0" aria-haspopup="listbox" aria-expanded="false">
        <span class="vfitz-vehicle-label">${this.escapeHtml(this.vehicle_null_text)}</span>
        <span class="vfitz-arrow-icon" style="display: none;" aria-hidden="true"></span>
        <div class="vfitz-garage-dropdown">
          <ul class="vfitz-garage-list" role="listbox"></ul>
        </div>
      </div>
    `;
  }

  initDOMReferences() {
    if (!this.hostElement) return;
    this.dom_vehicle_label = this.hostElement.querySelector('.vfitz-vehicle-label');
    this.dom_headerNav = this.hostElement.querySelector('.vfitz-garage-nav');
    this.dom_dropdown = this.hostElement.querySelector('.vfitz-garage-dropdown');
    this.dom_arrow = this.hostElement.querySelector('.vfitz-arrow-icon');
  }

  initWithEventCheck() {
    if (this.isInitialized) return;

    if (typeof vfitzKey !== 'undefined' && typeof vfitzKey.fn?.getGarageData === 'function') {
      this.runGarageInit();
      return;
    }

    const handler = () => {
      window.removeEventListener('vfitzInitMenuFirst', handler);
      this.runGarageInit();
    };
    window.addEventListener('vfitzInitMenuFirst', handler);

    setTimeout(() => {
      if (this.isInitialized) return;
      if (typeof vfitzKey !== 'undefined' && typeof vfitzKey.fn?.getGarageData === 'function') {
        window.removeEventListener('vfitzInitMenuFirst', handler);
        this.runGarageInit();
      }
    }, 1200);
  }

  runGarageInit() {
    if (this.isInitialized) return;
    this.isInitialized = true;

    try {
      const garageData = vfitzKey.fn.getGarageData();
      if (!garageData || garageData.length === 0) return;

      this.renderGarageList(garageData);

      if (garageData.length > 1) {
        if (this.dom_arrow) this.dom_arrow.style.display = 'inline-block';
        if (this.dom_headerNav) this.dom_headerNav.classList.add('has-multiple');
      }

      this.currentIndex = 0;
      this.cookieValue = garageData[0];
      this.garage_param = this.cookieValue.param;

      if (this.garage_param) {
        window.searchParams = this.garage_param;
        this.renderVehicleInfo();
        this.highlightActiveItem(0);
      }
    } catch (e) {
      console.error('Error in runGarageInit:', e);
    }
  }

  renderGarageList(garageData) {
    if (!this.hostElement) return;
    const listContainer = this.hostElement.querySelector('.vfitz-garage-list');
    if (!listContainer) return;

    listContainer.innerHTML = garageData.map((item, index) => {
      const itemLabel = this.getVehicleInfo(item.param) || `Vehicle #${index + 1}`;
      return `<li data-garageid="${index}" class="vfitz-garage-item" role="option" aria-selected="false">${this.escapeHtml(itemLabel)}</li>`;
    }).join('');
  }

  highlightActiveItem(index) {
    if (!this.hostElement) return;
    const items = this.hostElement.querySelectorAll('.vfitz-garage-item');
    items.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  renderVehicleInfo() {
    if (!window.searchParams) return;
    const label = this.getVehicleInfo(window.searchParams);
    if (!this.dom_vehicle_label || !this.dom_headerNav) return;

    if (label && label.trim() !== '') {
      this.dom_vehicle_label.innerText = label;
      this.dom_headerNav.classList.add('has-vehicle');
    } else {
      this.dom_vehicle_label.innerText = this.vehicle_null_text;
      this.dom_headerNav.classList.remove('has-vehicle');
    }
  }

  getVehicleInfo(params) {
    if (!params) return '';
    try {
      const filteredData = {};
      Object.keys(params)
        .filter(key => this.searchParamsAllowKeys.includes(key) && params[key] && params[key].length > 0)
        .forEach(key => { filteredData[key] = params[key]; });

      const levelIds = (typeof vfitz !== 'undefined' && vfitz.config?.level_ids)
        ? vfitz.config.level_ids
        : ['year', 'make', 'model'];

      return levelIds
        .map(key => filteredData[key])
        .filter(Boolean)
        .join(' ')
        .replace(/-/g, ' ');
    } catch (e) {
      console.error('Error in getVehicleInfo:', e);
      return '';
    }
  }

  escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  bindEvents() {
    console.log("bindEvents")
    if (!this.hostElement) return;

    // Key fix: listen directly on the outermost host node (the node proven to be clickable)
    this.hostElement.addEventListener('click', (event) => {
      // Stop the event from bubbling up to the form, preventing conflicting logic from firing
      event.preventDefault();
      event.stopPropagation();

      const itemClick = event.target.closest('[data-garageid]');

      if (itemClick) {
        this.handleGarageItem(itemClick);
        this.closeDropdown();
      } else {
        // Clicked on the main button area
        this.handleNavActivate();
      }
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  handleNavActivate() {
    if (!this.dom_headerNav) return;
    
    // If there are multiple vehicles, toggle the dropdown open/closed
    if (this.dom_headerNav.classList.contains('has-multiple')) {
      this.toggleDropdown();
      return;
    }

    // If there is only 1 vehicle, the click directly triggers the vehicle filter search
    if (this.dom_headerNav.classList.contains('has-vehicle')) {
      const firstItem = this.hostElement.querySelector('[data-garageid="0"]');
      if (firstItem) this.handleGarageItem(firstItem);
    }
  }

  toggleDropdown() {
    if (!this.dom_headerNav) return;
    if (this.dom_headerNav.classList.contains('is-open')) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    if (!this.dom_headerNav) return;
    this.dom_headerNav.classList.add('is-open');
    this.dom_headerNav.setAttribute('aria-expanded', 'true');
  }

  closeDropdown() {
    if (!this.dom_headerNav) return;
    this.dom_headerNav.classList.remove('is-open');
    this.dom_headerNav.setAttribute('aria-expanded', 'false');
  }

  onDocumentClick(event) {
    if (this.hostElement && !this.hostElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') this.closeDropdown();
  }

  handleGarageItem(element) {
    try {
      if (typeof vfitzKey === 'undefined') return;

      const garageid = element.dataset.garageid;
      const index = Number(garageid);
      const garageData = vfitzKey.fn.getGarageData()[garageid];

      if (garageData && garageData.param) {
        this.currentIndex = index;
        this.cookieValue = garageData;
        window.searchParams = garageData.param;
        this.renderVehicleInfo();
        this.highlightActiveItem(index);

        const actionUrl = "/search" + `?m=${encodeURIComponent(JSON.stringify(window.searchParams))}`;
        // console.log({ actionUrl });        
        window.location.href = actionUrl;

        // const selectorScope = (typeof vfitz !== 'undefined' && vfitz.config) ? (vfitz.config.selectorScope || '') : '';
        // const searchBtn = document.querySelector(`#vfitz_search_btn${selectorScope}`);
        // if (searchBtn) {
        //   searchBtn.click();
        // } else if (typeof vfitz$ !== 'undefined') {
        //   vfitz$(`#vfitz_search_btn${selectorScope}`).click();
        // }
      }
    } catch (e) {
      console.error('Error in handleGarageItem:', e);
    }
  }
}

(function bootVFitzGarage() {
  const SCAN_INTERVAL = 300;
  const MAX_DURATION = 15000; // Keep scanning for 15s to cover duplicate nodes that appear late or get rebuilt
  let elapsed = 0;

  function scanAndInit() {
    const config = window.vfitzGarageConfig || {};
    const selector = config.targetSelector || '#vfitz-mygarage';

    // Key: querySelectorAll returns ALL nodes with the same selector, not only the first one
    document.querySelectorAll(selector).forEach((node) => {
      if (node.__vfitzGarageInited) return; // Skip already-initialized nodes to avoid double binding
      node.__vfitzGarageInited = true;
      try {
        new VFitzMyGarageClassicManager().initWithNode(node);
      } catch (e) {
        console.error('VFitz garage init failed:', e);
        node.__vfitzGarageInited = false;   // On failure, allow a retry on the next pass
      }
    });
  }

  function loop() {
    scanAndInit();
    elapsed += SCAN_INTERVAL;
    if (elapsed < MAX_DURATION) setTimeout(loop, SCAN_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loop);
  } else {
    loop();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
